import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...this.props}><path fill="currentColor" fillRule="evenodd" d="M1.73 7L8.023.707 7.316 0l-7 7H0v1h.293l7.34 7.34.708-.706L1.707 8H16V7H1.73z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/widget/containers/share-overlay/embed-form/header/back.svg